import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { ArenaConfig } from '../types';
import { useStringsContext } from '../../../../contexts/strings';

const styles: SxStyle = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  saveButton: {
    marginRight: '10px',
    marginTop: '20px',
  },
};

export default function AppWifiCardForm({
  arenaConfig,
  submitNewMessageConfig,
}: {
  arenaConfig: ArenaConfig;
  submitNewMessageConfig: (message: ArenaConfig['message']) => void;
}) {
  const { strings } = useStringsContext();
  const { message } = arenaConfig;

  const [messageHeader, setMessageHeader] = useState(message.header);
  const [messageBody, setMessageBody] = useState(message.body);
  const [messageActionText, setMessageActionText] = useState(message.actionText);
  const [messageBackgroundImage, setMessageBackgroundImage] = useState(message.backgroundImage);
  const [messageColor, setMessageColor] = useState(message.color);

  const onChangeHeader = (e: any) => {
    setMessageHeader(e.target.value);
  };

  const onChangeBody = (e: any) => {
    setMessageBody(e.target.value);
  };

  const onChangeActionText = (e: any) => {
    setMessageActionText(e.target.value);
  };

  const onChangeBackgroundImage = (e: any) => {
    setMessageBackgroundImage(e.target.value);
  };

  const onChangeColor = (e: any) => {
    setMessageColor(e.target.value);
  };

  const resetForm = () => {
    setMessageHeader(message.header);
    setMessageBody(message.body);
    setMessageBackgroundImage(message.backgroundImage);
    setMessageColor(message.color);
  };

  const saveConfiguration = () => {
    const configuration = {
      header: messageHeader,
      body: messageBody,
      actionText: messageActionText,
      color: messageColor,
      backgroundImage: messageBackgroundImage,
    };

    submitNewMessageConfig(configuration);
    console.log('Saving configuration: ', configuration);
  };

  const showSaveAndResetButton =
    messageHeader !== message.header ||
    messageBody !== message.body ||
    messageBackgroundImage !== message.backgroundImage ||
    messageColor !== message.color;

  return (
    <>
      <TextField
        id="outlined-full-width"
        label={strings.wifi.labelHeader}
        value={messageHeader}
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        onChange={onChangeHeader}
      />
      <TextField
        id="outlined-full-width"
        label={strings.wifi.labelBody}
        value={messageBody}
        fullWidth
        margin="normal"
        variant="outlined"
        onChange={onChangeBody}
      />
      <TextField
        id="outlined-full-width"
        label={strings.wifi.labelActionText}
        value={messageActionText}
        fullWidth
        margin="normal"
        variant="outlined"
        onChange={onChangeActionText}
      />
      <TextField
        id="outlined-full-width"
        label={strings.wifi.labelBackgroundImage}
        defaultValue={messageBackgroundImage}
        fullWidth
        margin="normal"
        variant="outlined"
        onChange={onChangeBackgroundImage}
      />
      <TextField
        id="outlined-full-width"
        label={strings.wifi.labelColor}
        value={messageColor}
        fullWidth
        margin="normal"
        variant="outlined"
        onChange={onChangeColor}
      />
      {showSaveAndResetButton && (
        <Button
          sx={styles.saveButton}
          variant="contained"
          color="primary"
          onClick={() => resetForm()}
        >
          {strings.actions.cancel}
        </Button>
      )}
      {showSaveAndResetButton && (
        <Button
          sx={styles.saveButton}
          variant="contained"
          color="primary"
          onClick={saveConfiguration}
        >
          {strings.actions.save}
        </Button>
      )}
    </>
  );
}
